"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouncilTax$ = exports.CouncilTax$outboundSchema = exports.CouncilTax$inboundSchema = void 0;
exports.councilTaxToJSON = councilTaxToJSON;
exports.councilTaxFromJSON = councilTaxFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const counciltaxbands_js_1 = require("./counciltaxbands.js");
/** @internal */
exports.CouncilTax$inboundSchema = z.object({
    band: counciltaxbands_js_1.CouncilTaxBands$inboundSchema,
    current_annual_charge: z.number(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "current_annual_charge": "currentAnnualCharge",
    });
});
/** @internal */
exports.CouncilTax$outboundSchema = z.object({
    band: counciltaxbands_js_1.CouncilTaxBands$outboundSchema,
    currentAnnualCharge: z.number(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        currentAnnualCharge: "current_annual_charge",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CouncilTax$;
(function (CouncilTax$) {
    /** @deprecated use `CouncilTax$inboundSchema` instead. */
    CouncilTax$.inboundSchema = exports.CouncilTax$inboundSchema;
    /** @deprecated use `CouncilTax$outboundSchema` instead. */
    CouncilTax$.outboundSchema = exports.CouncilTax$outboundSchema;
})(CouncilTax$ || (exports.CouncilTax$ = CouncilTax$ = {}));
function councilTaxToJSON(councilTax) {
    return JSON.stringify(exports.CouncilTax$outboundSchema.parse(councilTax));
}
function councilTaxFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CouncilTax$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CouncilTax' from JSON`);
}
//# sourceMappingURL=counciltax.js.map